<!-- Header -->
<div class="header-icons">
  <app-table-header
    #header
    [showHeader]="false"
    [hasFilter]="false"
    [hasSearchBar]="true"
    [rightPadding]="2"
    [hasAddItem]="false"
    [hasCollapsedPadding]="false"
    (searchEvent)="search($event)"
    (searchClear)="clearSearch()"
    (exportExcelEvent)="exportExcel()"
  >
    <div class="plan-date">
      <app-form-date-picker
        [(ngModel)]="planDate"
        [disabled]="true"
      ></app-form-date-picker>
    </div>

    <div class="selected-route">
      <img [src]="SRC.LOCATION_DISABLED" alt="route-id" />
      <span> {{ CONSTANTS.ROUTE }} {{ selectedRoute }}</span>
    </div>
  </app-table-header>
</div>
<!-- Body -->
<cdk-virtual-scroll-viewport itemSize="50">
  <div id="operation-route-details">
    <div class="operation-route-details-table-container">
      <table mat-table [dataSource]="dataSource">
        <div>
          <div>
            <!-- Stop type -->
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef id="stopType-headers">
                <ion-row class="th-text"> {{ HEADERS.TYPE }} </ion-row>
              </th>
              <ng-container
                mat-cell
                *matCellDef="let routeDetail; let i = index"
              >
                @if (routeDetail.displayStop) {
                  <td
                    [attr.rowspan]="getRowSpan(routeDetail)"
                    [ngClass]="{
                      'background-color-grey': routeDetail.index % 2 !== 0,
                    }"
                    headers="stopType-headers"
                    class="display-stop"
                  >
                    <div class="stop-types">
                      @switch (routeDetail.type) {
                        <!-- On Demand -->
                        @case ("onDemand") {
                          <img
                            [src]="SRC.PHONE"
                            alt="stop type"
                            class="stop-type-icons"
                          />
                        }
                        <!-- Pickup Stop -->
                        @case ("PS") {
                          <img
                            [src]="SRC.PICKUP"
                            alt="stop type"
                            class="stop-type-icons"
                          />
                        }
                        <!-- Delivery Stop -->
                        @case ("DS") {
                          <img
                            [src]="SRC.DELIVERY"
                            alt="stop type"
                            class="stop-type-icons"
                          />
                        }
                        <!-- Unkown Stop -->
                        @case ("U") {
                          <span>{{ CONSTANTS.UNKNOWN }}</span>
                        }
                      }
                    </div>
                  </td>
                }
              </ng-container>
            </ng-container>

            <!-- Density -->
            <ng-container matColumnDef="density">
              <th mat-header-cell *matHeaderCellDef id="density-headers">
                <ion-row class="th-text">
                  {{ HEADERS.DENSITY }}
                </ion-row>
              </th>
              <ng-container
                mat-cell
                *matCellDef="let routeDetail; let i = index"
              >
                @if (routeDetail.displayStop) {
                  <td
                    [attr.rowspan]="getRowSpan(routeDetail)"
                    [ngClass]="{
                      'background-color-grey': routeDetail.index % 2 !== 0,
                    }"
                    headers="density-headers"
                    class="left-data-column multi-column"
                  >
                    {{ routeDetail.density }}
                  </td>
                }
              </ng-container>
            </ng-container>

            <!-- Consignee -->
            <ng-container matColumnDef="cosignee">
              <th mat-header-cell *matHeaderCellDef id="cosignee-headers">
                <ion-row class="th-text"> {{ HEADERS.CONSIGNEE }}</ion-row>
              </th>
              <ng-container
                mat-cell
                *matCellDef="let routeDetail; let i = index"
              >
                @if (routeDetail.displayStop) {
                  <td
                    [attr.rowspan]="getRowSpan(routeDetail)"
                    [ngClass]="{
                      'background-color-grey': routeDetail.index % 2 !== 0,
                    }"
                    headers="cosignee-headers"
                    class="left-data-column multi-column"
                  >
                    {{ routeDetail.cosignee }}
                  </td>
                }
              </ng-container>
            </ng-container>

            <!-- Address -->
            <ng-container matColumnDef="address">
              <th mat-header-cell *matHeaderCellDef id="address-headers">
                <ion-row class="th-text"> {{ HEADERS.ADDRESS }}</ion-row>
              </th>

              <ng-container
                mat-cell
                *matCellDef="let routeDetail; let i = index"
              >
                @if (routeDetail.displayStop) {
                  <td
                    [attr.rowspan]="getRowSpan(routeDetail)"
                    [ngClass]="{
                      'background-color-grey': routeDetail.index % 2 !== 0,
                    }"
                    headers="address-headers"
                    class="left-data-column multi-column"
                  >
                    <div>{{ routeDetail.address }}</div>
                    <div>{{ routeDetail.city }} {{ routeDetail.postal }}</div>
                  </td>
                }
              </ng-container>
            </ng-container>

            <!-- Stop Date -->
            <div class="form-group">
              <ng-container matColumnDef="stopDate">
                <th mat-header-cell *matHeaderCellDef id="stop-date-headers">
                  <ion-row class="th-text"> {{ HEADERS.STOP_DATE }}</ion-row>
                </th>
                <ng-container
                  mat-cell
                  *matCellDef="let routeDetail; let i = index"
                >
                  @if (routeDetail.displayStop) {
                    <td
                      [attr.rowspan]="getRowSpan(routeDetail)"
                      [ngClass]="{
                        'background-color-grey': routeDetail.index % 2 !== 0,
                      }"
                      headers="stop-date-headers"
                      class="right-data-column route-border multi-column"
                    >
                      <ion-row class="stop-date-row">
                        <ion-col>
                          {{
                            routeDetail.stopDate.getTime()
                              ? (routeDetail.stopDate | date: "MM/dd/yyyy")
                              : ""
                          }}
                        </ion-col>
                      </ion-row>
                    </td>
                  }
                </ng-container>
              </ng-container>
            </div>

            <!-- Complete Time -->
            <div class="form-group">
              <ng-container matColumnDef="completionTime">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  id="complete-time-headers"
                >
                  <ion-row class="th-text">
                    {{ HEADERS.COMPLETION_TIME }}
                  </ion-row>
                </th>
                <ng-container
                  mat-cell
                  *matCellDef="let routeDetail; let i = index"
                >
                  @if (routeDetail.displayStop) {
                    <td
                      [attr.rowspan]="getRowSpan(routeDetail)"
                      [ngClass]="{
                        'background-color-grey': routeDetail.index % 2 !== 0,
                      }"
                      headers="complete-time-headers"
                      class="stop-date-border right-data-column multi-column"
                    >
                      {{ routeDetail.completionTime }}
                    </td>
                  }
                </ng-container>
              </ng-container>
            </div>

            <!-- Tracking number -->
            <ng-container matColumnDef="trackingNumber">
              <th mat-header-cell *matHeaderCellDef id="trackingNumber-headers">
                <ion-row class="th-text">
                  {{ HEADERS.TRACKING_NUMBER }}</ion-row
                >
              </th>

              <td
                mat-cell
                *matCellDef="let routeDetail"
                [ngClass]="{
                  'background-color-grey': routeDetail.index % 2 !== 0,
                }"
                headers="trackingNumber-headers"
                class="left-data-column multi-column"
              >
                <ion-row>
                  <ion-col>
                    {{ routeDetail.trackingNumber }}
                  </ion-col>
                </ion-row>
              </td>
            </ng-container>

            <!-- Scan Code -->
            <div class="form-group">
              <ng-container matColumnDef="scanCode">
                <th mat-header-cell *matHeaderCellDef id="scanCode-headers">
                  <ion-row class="th-text">
                    {{ HEADERS.SCAN_CODE }}
                  </ion-row>
                </th>
                <ng-container
                  mat-cell
                  *matCellDef="let routeDetail; let i = index"
                >
                  <td
                    [ngClass]="{
                      'background-color-grey': routeDetail.index % 2 !== 0,
                    }"
                    headers="scanCode-headers"
                    class="sub-table-data left-data-column"
                  >
                    {{
                      routeDetail.isStopComplete ? routeDetail.scancodeDesc : ""
                    }}
                  </td>
                </ng-container>
              </ng-container>
            </div>

            <!-- Description -->
            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef id="description-headers">
                <ion-row class="th-text">
                  {{ HEADERS.DESCRIPTION }}
                </ion-row>
              </th>
              <ng-container
                mat-cell
                *matCellDef="let routeDetail; let i = index"
              >
                <td
                  [ngClass]="{
                    'background-color-grey': routeDetail.index % 2 !== 0,
                  }"
                  headers="description-headers"
                  class="left-data-column"
                >
                  {{ routeDetail.remark }}
                </td>
              </ng-container>
            </ng-container>

            <!-- Amount Due -->
            <ng-container matColumnDef="amtDue">
              <th mat-header-cell *matHeaderCellDef id="amtDue-headers">
                <ion-row class="th-text right-align">
                  {{ HEADERS.AMOUNT_DUE }}
                </ion-row>
              </th>
              <ng-container
                mat-cell
                *matCellDef="let routeDetail; let i = index"
              >
                <td
                  [ngClass]="{
                    'background-color-grey': routeDetail.index % 2 !== 0,
                  }"
                  headers="amtDue-headers"
                  class="right-data-column"
                >
                  {{ routeDetail.amtDue }}
                </td>
              </ng-container>
            </ng-container>

            <!-- Amount Collected -->
            <ng-container matColumnDef="amtCollected">
              <th
                mat-header-cell
                *matHeaderCellDef
                id="amountCollected-headers"
              >
                <ion-row class="th-text right-align">
                  {{ HEADERS.AMOUNT_COLLECTED }}
                </ion-row>
              </th>
              <ng-container
                mat-cell
                *matCellDef="let routeDetail; let i = index"
              >
                <td
                  [ngClass]="{
                    'background-color-grey': routeDetail.index % 2 !== 0,
                  }"
                  headers="amountCollected-headers"
                  class="right-data-column"
                >
                  {{ routeDetail.amtCollected }}
                </td>
              </ng-container>
            </ng-container>

            <!-- Action -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef id="action-headers">
                <ion-row class="th-text center-align">
                  {{ ACTIONS_TEXT }}
                </ion-row>
              </th>
              <ng-container
                mat-cell
                *matCellDef="let routeDetail; let i = index"
              >
                @if (routeDetail.displayStop) {
                  <td
                    [attr.rowspan]="getRowSpan(routeDetail)"
                    [ngClass]="{
                      'background-color-grey': routeDetail.index % 2 !== 0,
                    }"
                    headers="action-headers"
                    class="actions-border multi-column"
                  >
                    <button
                      class="button-for-icons"
                      (click)="editStop(routeDetail, i)"
                    >
                      <img [src]="IMAGES.EDIT_BLUE" alt="edit" />
                    </button>
                  </td>
                }
              </ng-container>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td
                class="mat-cell no-border no-results-found"
                [attr.colspan]="displayedColumns.length"
              >
                <app-no-results-found></app-no-results-found>
              </td>
            </tr>
          </div>
        </div>
      </table>
    </div>
  </div>
</cdk-virtual-scroll-viewport>
